import Header from "../components/Header"
import Footer from "../components/Footer"
export default function News(){
    return(
        <>
            <Header/>
            <h1 className="text-center text-xl font-bold">News</h1>
        </>
    )
}